import React from 'react';
import { AlertTriangle, Trash2, CheckCircle, XCircle, Info } from 'lucide-react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'تأكيد',
  cancelText = 'إلغاء',
  type = 'warning', // warning, danger, success, info
  icon = null,
  loading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    if (icon) return icon;
    switch (type) {
      case 'danger':
        return <Trash2 size={28} />;
      case 'success':
        return <CheckCircle size={28} />;
      case 'info':
        return <Info size={28} />;
      case 'error':
        return <XCircle size={28} />;
      case 'warning':
      default:
        return <AlertTriangle size={28} />;
    }
  };

  const handleConfirm = () => {
    if (!loading) {
      onConfirm();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !loading) {
      onClose();
    }
  };

  return (
    <div className="confirm-overlay" onClick={handleOverlayClick}>
      <div className={`confirm-dialog confirm-${type}`}>
        <div className="confirm-icon">
          {getIcon()}
        </div>
        <div className="confirm-content">
          <h3 className="confirm-title">{title}</h3>
          <p className="confirm-message">{message}</p>
        </div>
        <div className="confirm-actions">
          <button 
            className="confirm-btn cancel" 
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            className={`confirm-btn primary ${type}`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? (
              <span className="btn-loader"></span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
